module.exports = __webpack_public_path__ + "img/neobet_2026.7b2c0bf5.png";